import { createGlobalStyle } from 'styled-components';
import colors from './colors.json';

const {
    color: {
      main: { burgundy: mainBurgundy },
      point: { burgundy: pointBurgundy, gold },
      sub: { burgundy1, burgundy2 },
      base: { gray, ivory, beige }
    }
  } = colors;

export const GlobalStyles = createGlobalStyle`

    :root {
    --main-burgundy: ${mainBurgundy.value};
    --point-gold: ${gold.value};
    --sub-burgundy1: ${burgundy1.value};
    --base-gray: ${gray.value};
    --base-ivory: ${ivory.value};
    --base-beige: ${beige.value};

    --point-burgundy: ${pointBurgundy.value};
    --sub-burgundy2: ${burgundy2.value};

    }

    .inner {
    width: 90%;
    max-width: 1000px;
    margin: 0 auto;
    }

    .flex {
    display: flex;
    }

    .flex-wrap {
    flex-wrap: wrap;
    }

    .flex-between {
    justify-content: space-between;
    }

    .flex-center {
    justify-content: center;
    }

    .margin-center {
    margin: 0 auto;
    }

    .text-center {
    text-align: center;
    }

    p {
        font-family: 'Pretendard',sans-serif;
        font-size: 18px;
        line-height: 1.5;

    }

    h2 {
        font-family: 'Pretendard',sans-serif;
        font-size: 60px;
        font-weight: 500;
        line-height: 1.2;
    }
    
    h3 {
        font-family: 'Pretendard',sans-serif;
        font-size: 30px;
        font-weight: 700;
        line-height: 1.5;
    }
            
    h4 {
        font-family: 'Pretendard',sans-serif;
        font-size: 18px;
        font-weight: 700;
        line-height: 1.5;
    }
                
    h5 {
        font-family: 'Pretendard',sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.5;
        padding: 5px 0;
    }

    h6 {
        font-family: 'Pretendard',sans-serif;
        display: block;
        width: 100px;
        padding: 3px 0;
        margin: 10px auto;
        border-radius: 50px;
        background-color: var(--main-burgundy);
        color: #fff;

        font-size: 16px;
        font-weight: 700;
    }        

     
    .btn-light {
        width: 180px;
        height: 40px;
        border: 1px solid var(--main-burgundy);
        border-radius: 50px;
        background-color: #fff;
        color: var(--main-burgundy);
        font-size: 16px;
        font-weight: 700;
        line-height: 0;
        transition: all 0.1s linear;
        cursor: pointer;
    }

    .btn-light:hover {
        border: 1px solid #fff;
        background-color: var(--main-burgundy);
        color: #fff;
    }

    .btn-dark {
        width: 180px;
        height: 40px;
        background-color: var(--main-burgundy);
        border: 1px solid #fff;
        border-radius: 50px;
        color: #fff;
        
        font-size: 16px;
        font-weight: 700;
        line-height: 0;
        transition: all 0.1s linear;
        cursor: pointer;
    }

    .btn-dark:hover {
        background-color: #fff;
        border: 1px solid #fff;
        color: var(--main-burgundy);
        
    }

    .section {
        padding: 70px 0;
        font-family: 'Pretendard', sans-serif;
    }

    .logo-home {
        max-width: 200px;
        padding: 15px 0;
    }

    button{
        all: unset;
    }

    a {
        font-family: 'Pretendard',sans-serif;
        text-decoration: none;
        cursor: pointer;
    }
`